interface RegisterServiceWorkerOptions {
  isProduction?: boolean;
  scriptUrl?: string;
  scope?: string;
}

const DEFAULT_SW_SCRIPT_URL = '/sw.js';
const DEFAULT_SW_SCOPE = '/';

export function registerServiceWorker({
  isProduction = import.meta.env.PROD,
  scriptUrl = DEFAULT_SW_SCRIPT_URL,
  scope = DEFAULT_SW_SCOPE,
}: RegisterServiceWorkerOptions = {}): void {
  if (!isProduction || typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  const register = () => {
    void navigator.serviceWorker.register(scriptUrl, { scope }).catch((error: unknown) => {
      const message = error instanceof Error ? error.message : String(error);
      console.warn(`Service worker registration failed for ${scriptUrl}: ${message}`);
    });
  };

  if (document.readyState === 'complete') {
    register();
    return;
  }

  window.addEventListener('load', register, { once: true });
}
